let html = `<div class="account-modal-split">
    <div class="account-modal-split__qr">
        <img class="account-modal-split__qr-img hide" />
        <div class="account-modal-split__qr-code"></div>
        <div class="account-modal-split__qr-text">#{account_qr_code}</div>
    </div>

    <div class="account-modal-split__info">
        <div class="account-modal-split__text">#{account_device_auth_needed}</div>

        <div class="account-modal-split__text">#{account_device_go_to_bot}</div>

        <a class="account-modal-split__bot-link" target="_blank" rel="noopener"></a>

        <div class="account-modal-split__text">#{account_device_select_devices}</div>

        <div class="account-modal-split__text">#{account_device_enter_code}</div>

        <div class="account-modal-split__device-code"></div>

        <div class="account-modal-split__status"></div>
    </div>
</div>`

export default html